<template>
    <div v-if="isActive" class="progress-wrapper">
        <div class="progress-container">
            <v-progress-circular
                :rotate="360"
                :size="80"
                :width="10"
                :value="progress"
                color="#967adc"
            >
                {{ progress }}%
            </v-progress-circular>
        </div>
        <p>{{ statusMessage }}</p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { uploadProgressGetterTypes } from '@/store/modules/upload-progress'

export default {
    name: 'OrdersUploadedProgress',
    computed: {
        ...mapGetters('uploadProgress', {
            currentStep: uploadProgressGetterTypes.CURRENT_STEP,
            progress: uploadProgressGetterTypes.PROGRESS,
            isActive: uploadProgressGetterTypes.IS_ACTIVE,
            statusMessage: uploadProgressGetterTypes.STATUS_MESSAGE,
        }),
    },
}
</script>

<style scoped lang="scss">
.progress-wrapper {
    position: fixed;
    width: 100%;
    height: 100vh;
    padding: 8px;
    background: radial-gradient(
        circle,
        rgba(255, 255, 255, 1) 5%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0.5) 100%
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.progress-container {
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}

p {
    margin-top: 10px;
}
</style>
